import React, { useState } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { object } from 'prop-types';
import { PricingDetails, Text } from '@landtrustinc/design-system';
import css from './InquiryPricingDetails.module.css';

const InquiryPricingDetailsComponent = ({ pricingView, intl }) => {
  const [expanded, setExpanded] = useState(false);

  if (!pricingView) {
    return null;
  }

  return (
    <PricingDetails variant="dashed">
      <PricingDetails.Section
        eyebrow={intl.formatMessage({ id: 'InquiryWizard.bookingRequestEstimate' })}
        items={expanded ? pricingView.items : undefined}
        total={{
          label: intl.formatMessage({ id: 'InquiryWizard.bookingRequestTotalAllFees' }),
          amount: pricingView.totalAmount,
        }}
        cta={
          <button
            type="button"
            className={css.priceToggle}
            aria-expanded={expanded}
            data-testid="price-details-toggle"
            onClick={() => setExpanded(current => !current)}
          >
            <Text as="span" size="sm" fontWeight="semibold">
              {intl.formatMessage({
                id: expanded ? 'InquiryWizard.hidePriceDetails' : 'InquiryWizard.showPriceDetails',
              })}
            </Text>
          </button>
        }
        footnote={
          expanded ? intl.formatMessage({ id: 'InquiryWizard.inquiryNotBooking' }) : undefined
        }
      />
    </PricingDetails>
  );
};

InquiryPricingDetailsComponent.defaultProps = {
  pricingView: null,
};

InquiryPricingDetailsComponent.propTypes = {
  pricingView: object,
  intl: intlShape.isRequired,
};

export default injectIntl(InquiryPricingDetailsComponent);
